// src/persistencia/productoService.ts
import { getToken } from './authUtils';
import ServicioURLManager from './servicioUrlManager';

export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  image: string;
  category: string;
  discount?: number;
  destacado?: boolean;
}

const generarImagenProducto = (nombre: string): string => {
  const texto = encodeURIComponent(nombre);
  const seed = Math.floor(Math.random() * 1000);
  return `https://api.a0.dev/assets/image?text=${texto}&aspect=1:1&seed=${seed}`;
};

/**
 * ## Función: fetchProductosDesdeAPI
 * Consulta productos desde la API y permite filtrar por categoría y/o destacados.
 *
 * @param {string} [categoriaId] - ID de la categoría (opcional).
 * @param {string} [oferta] - Filtra si está en oferta ("S" para destacados, "" por defecto).
 * @returns {Promise<Product[]>} Lista de productos transformados.
 */
export const fetchProductosDesdeAPI = async (
  categoriaId: string = '',
  oferta: string = ''
): Promise<Product[]> => {
  try {
    const serverUrl = await new Promise<string>((resolve, reject) => {
      ServicioURLManager.getUrlServicios((result, error) => {
        if (error || !result?.[0]?.Url) {
          reject("No se pudo obtener la URL del servidor.");
        } else {
          resolve(result[0].Url);
        }
      });
    });
console.log("__________"+oferta)

    const bodyParams: Record<string, string> = {
      token: getToken(),
      producto: '',
      tipiva: '',
      categoria: categoriaId,
      familia: '0',
      grupo: '0',
      IdProveedor: '0',
      activos: 'S',
      ProdTip: '',
      CritTc: '999997',
      clientId: '',
      Valorizado: '',
      Fecha: '',
      CritCos: '',
      oferta: oferta
    };

    console.log(bodyParams)


    const response = await fetch(`${serverUrl}/getCatalogoActivo`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(bodyParams)
    });

    const text = await response.text();
    console.log("Contenido bruto:", text);

    const dataLines = text
      .split('\n')
      .filter(line => line.trim().startsWith('data: '))
      .map(line => line.replace(/^data: /, ''));

    const lastData = dataLines.pop();
    if (!lastData) throw new Error("No se encontró contenido válido para procesar.");

    const json = JSON.parse(lastData);
    if (!Array.isArray(json?.data)) return [];

    return json.data.map((item: any): Product => ({
      id: String(item.Id || item.id || item.Codigo || Math.random()),
      name: item.Producto || 'Sin nombre',
      description: (item.Descripcion_Avanzada || '').trim(),
      price: Number(item.PU || 0),
      image: item.Imagenes?.[0] || generarImagenProducto(item.Producto || 'producto'),
      category: item.NameCate || 'Sin categoría',
      discount: item.oferta === 'S' ? 10 : 0,
      destacado: item.oferta === 'S'
    }));
  } catch (error) {
    console.error("Error al parsear JSON:", error);
    return [];
  }
};
